/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2023-03-27 20:33:18
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-04-25 20:34:42
 * @FilePath: \baishu_react_ui\src\components\BsySlidePane\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import ReactDOM from "react-dom";

import Dlg from "./dlg";
import { BsyUtils } from "../../utils/Utils";

const BsySlidePane = (props) =>
  new Promise((fulfill) => {
    // 此处参数需用圆括号，否则 eslint 报错
    let holder;
    let rootTokenClass = "rootTokenCls" + new Date().getTime();
    holder = document.createElement("div");
    holder.style.zIndex = window.FX.STATIC.zIndex++;
    holder.classList.add("bsy-x-slider");
    setTimeout(() => {
      holder.classList.add("fadein");
    }, 30);
    holder.classList.add(rootTokenClass);
    !!props.theme && holder.classList.add(props.theme);
    document.body.appendChild(holder);

    if (props.theme && props.theme.includes('bsy-graffiti')) {
      holder.addEventListener("click", (e) => {
        e.stopPropagation();
        e.preventDefault();
      });
      holder.addEventListener("mousedown", (e) => {
        e.stopPropagation();
        e.preventDefault();
      });
    }



    let CleanRootNode = (e) => {
      // 当界面被点击时自动清理元素
      // e 为null，组件自己清理自己
      // 无法找到父级元素 rootTokenClass 说明点击了其他任意位置
      if (!e || !BsyUtils.closestClass(e.target, rootTokenClass)) {
        ReactDOM.unmountComponentAtNode(holder);
        holder.remove();
        document.removeEventListener("mouseup", CleanRootNode, false);
      }
    };
    // document.addEventListener('mouseup', CleanRootNode, false);

    const newProps = { ...props };
    newProps.onRemoveRoot = () => {
      //自动清理
      holder.classList.remove("fadein");
      setTimeout(() => {
        CleanRootNode();
      }, 218);
    };
    if (newProps.getContext) {
      newProps.getContext(newProps);
    }
    ReactDOM.render(<Dlg {...newProps} rootTokenClass />, holder);
  }).catch((res) => {
    console.error("BsySlidePane", res);
  });

export default BsySlidePane;
